<template>
  <v-container>
    <h1>INDICADORES</h1>
    <v-row class="text-center">
      <v-col cols="12" md="3">
        <h2 class="mt-4 mb-3">Modalidades de Ensino</h2>
        <Modalities :city="city" />
      </v-col>
      <v-col cols="12" md="3">
        <h2 class="mt-4 mb-3">Biblioteca</h2>
        <Library :city="city" />
      </v-col>
      <v-col cols="12" md="3">
        <h2 class="mt-4 mb-3">Sala de Informática</h2>
        <Computers :city="city" />
      </v-col>
      <v-col cols="12" md="3">
        <h2 class="mt-4 mb-3">Iniciação Científica</h2>
        <Research :city="city" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { cities } from "@/utils";
import Library from "@/components/charts/library";
import Computers from "@/components/charts/computers.vue";
import Modalities from "@/components/charts/modalities.vue";
import Research from "@/components/charts/research.vue";

export default {
  props: ["city"],
  components: {
    Library,
    Computers,
    Modalities,
    Research,
  },
  data() {
    return {
      cities,
      // city: "",
    };
  },
};
</script>